__turbopack_context__.v({
  "container": "ContentSection-module__Sn_5aW__container",
});
